import { render, staticRenderFns } from "./BenefitWithdrawLog.vue?vue&type=template&id=97bf44d0&scoped=true&"
import script from "./BenefitWithdrawLog.vue?vue&type=script&lang=js&"
export * from "./BenefitWithdrawLog.vue?vue&type=script&lang=js&"
import style0 from "./BenefitWithdrawLog.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BenefitWithdrawLog.vue?vue&type=style&index=1&id=97bf44d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bf44d0",
  null
  
)

export default component.exports